const INTERCEPT_SURVEY_THRESHOLD = 14;
const LOCAL_STORAGE_DISABLED_ERROR =
  "Please enable 'dom.storage.enabled' to allow preferences to be set.";

const LOCAL_STORAGE = 'ctui-preferences';

const NAMESPACE_PREFERENCES = {
  INTERCEPT_SURVEY: 'interceptSurvey',
  WELCOME: 'welcome',
  CREATE_TICKET_DRAFT: 'createTicketDraft',
  UPDATE_TICKET_DRAFT: 'updateTicketDraft',
};

export {
  INTERCEPT_SURVEY_THRESHOLD,
  LOCAL_STORAGE,
  NAMESPACE_PREFERENCES,
  LOCAL_STORAGE_DISABLED_ERROR,
};
